module.exports = __webpack_public_path__ + "static/media/img-exhibition-map-kr.f42cf118.png";